import CSSImage from '../images/techs/css.png';
import ReactImage from '../images/techs/react.png';
import GitHubLogo from '../../png-extras/github2.png';
import PythonLogo from '../images/techs/Python.png';
import JavascriptImage from '../images/techs/Javascript.png';
import HtmlImage from '../images/techs/HTML.png';
import * as S from './SkillsStyles';
import { useEffect, useState } from 'react';
import React from 'react';

const Skills = () => {
    const skills = [
        {
            title: "HTML",
            image: HtmlImage,
            percent: 80
        },
        {
            title: "CSS",
            image: CSSImage,
            percent: 90
        },
        {
            title: "JavaScript",
            image: JavascriptImage,
            percent: 50
        },
        {
            title: "React JS",
            image: ReactImage,
            percent: 55
        },
        {
            title: "Python",
            image: PythonLogo,
            percent: 40
        },
        {
            title: "GitHub",
            image: GitHubLogo,
            percent: 80
        }
    ];
    const [bandera, setBandera] = useState(false);
    const [progress, setProgress] = useState(new Array(skills.length).fill(0));


    useEffect(() => {
        const handleScroll = () => {
            const skillsSection = document.getElementById("skills");
            const animacionSkills = document.getElementById("infoskills");
            const animacionImageSkills = document.getElementById("imageskills");
            const posicionOb1 = animacionSkills.getBoundingClientRect().top;
            const tamañoDePantalla = window.innerHeight / 1.25;

            if (posicionOb1 < tamañoDePantalla && !bandera) {
                setBandera(true);
                animacionSkills.style.animation = "fadeInSkills 1s ease-out forwards";
                animacionImageSkills.style.animation = "fadeInSkills 1s ease-out forwards";
                skillsSection.style.animation = "fondoSkills 1.5s ease-out forwards";
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [bandera]);

    useEffect(() => {
        if (bandera) {
            console.log(bandera)
            const interval = setInterval(() => {
                setProgress((prevProgress) => {
                    return prevProgress.map((currentProgress, index) => {
                        if (currentProgress < skills[index].percent) {
                            return currentProgress + 1;
                        }
                        return currentProgress;
                    });
                });
            }, 30);

            return () => clearInterval(interval);
        }
    }, [bandera]);

    return (
        <S.ContainerAll id='skills'>
            <S.IdSkills id='infoskills'>
                Skills
            </S.IdSkills>
            <S.BarraGral id='imageskills'>
                {skills.map((skill, index) => (
                    <S.ProgressBar key={index}>
                        <S.BloqueUno>
                            <S.CircularProgress progress={progress[index]} />
                            <S.CircleIcon className='circleIcon'>
                                <img src={skill.image} alt={skill.title} />
                            </S.CircleIcon>
                        </S.BloqueUno>
                        <S.Porcentaje>{progress[index]}%</S.Porcentaje>
                    </S.ProgressBar>
                ))}
            </S.BarraGral>
        </S.ContainerAll>
    );
}

export default Skills;